// extracted by mini-css-extract-plugin
export default {"title":"xi9N75Sw69gaUhk2Ajzd","warningContainer":"bTtAihhJY2SZdsb4SBkQ","buttonsContainer":"fwjnuvhZNref_QhTw0MA","cancelBtn":"tIC9YsZEl1bQaBzo__Co"};